import { ContentContainer } from "containers";
import { PageTitle } from "shared";
import styled from "styled-components";

const Container = styled.div`
  margin-top: 16px;
  width: 100%;
`;

const PageText = styled.div`
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0;
  margin: 1em 0;
  color: rgba(31, 32, 33, 1);
`;

const Support = () => {
  return (
    <ContentContainer>
      <Container>
        <PageTitle>Поддержка</PageTitle>
        <PageText>
          По вопросам поддержки можно обратиться в{" "}
          <a
            href="https://max.ru/id7814693830_4_bot"
            target="_blank"
            rel="noopener noreferrer"
          >
            Max
          </a>
          {" "}или в{" "}
          <a
            href="https://t.me/pddtv_support_bot"
            target="_blank"
            rel="noopener noreferrer"
          >
            Телеграм
          </a>
        </PageText>
      </Container>
    </ContentContainer>
  );
};

export default Support;
